import React from 'react';

import {
    BookingSummary,
    formatBookingDate,
    formatBookingTimeRange,
} from '../bookings/adapters/bookingAdapter';

interface BookingDateTimeProps {
    summary: BookingSummary;
    showTime?: boolean;
    showIcons?: boolean;
    className?: string;
}

const BookingDateTime: React.FC<BookingDateTimeProps> = ({
    summary,
    showTime = true,
    showIcons = false,
    className = '',
}) => {
    const dateLabel = formatBookingDate(summary.date);
    const timeLabel = formatBookingTimeRange(summary.startTime, summary.endTime);

    return (
        <div className={`flex flex-col ${className}`.trim()}>
            <span className="text-sm text-slate-600">{dateLabel}</span>
            {showTime && (
                <span className="text-xs text-slate-400">
                    {showIcons ? '⏱ ' : ''}{timeLabel}
                </span>
            )}
        </div>
    );
};

export default BookingDateTime;
